import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import VisitorAccessCarLicenseList from './components/VisitorAccessCarLicenseList';

const { Cell } = ResponsiveGrid;

const VisitorAccessCarLicense = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="訪客車牌管理"
        breadcrumbs={[
          {
            name: '訪客門禁',
          },
          {
            name: '訪客車牌管理',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <VisitorAccessCarLicenseList />
    </Cell>
  </ResponsiveGrid>
);

export default VisitorAccessCarLicense;
